export const hasMargins = (i, hasInsideCovers, length) =>
  (hasInsideCovers ? i % 2 === 1 || i === length - 2 : i % 2 === 0) || i === 0;

// Is a hard-coded value for accurate calculations of scroll amounts / active pages
const defaultArgs = {
  marginWidth: 10,
  imageWidth: 200,
};

export const calculateActivePage = (scrollLeft, args = {}) => {
  const options = { ...defaultArgs, ...args };
  let i = 0;
  let marginWidth = 0;
  const width = (options.imageWidth + marginWidth);

  while (scrollLeft > width) {
    i++;
    marginWidth = hasMargins(i, options.hasInsideCovers, options.totalPageCount) ? options.marginWidth : 0;
    scrollLeft = scrollLeft - width;
  }

  return i;
};

export const calculateScrollAmount = (pageId, args = {}) => {
  const options = { ...defaultArgs, ...args };
  const arr = pageId - 1 >= 0 ? new Array(pageId - 1).fill(0) : [];
  const reduced = arr.reduce(
    (scrollAmount, _, i) =>
      scrollAmount +
      options.imageWidth +
      (hasMargins(i, options.hasInsideCovers, options.totalPageCount)
        ? options.marginWidth
        : 0),
    0,
  );
  return options.hasInsideCovers ? reduced - options.imageWidth : reduced;
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/BookPreview/ScrollingBook/helpers.js